
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { OdgReportingApiService } from "./api/odg-reporting.apiservice";
import { FileResultModel } from "src/app/shared/models/fileresult.model";
import { ExportOdgRequest } from "../models/api/requests/export-odg.apirequest";
import { OdgPrestationsConvivesRequest } from "../models/api/requests/odg-prestations-convives.apirequest";
import { OdgPrestationsConvivesResponse } from "../models/api/responses/odg-prestations-convives.apiresponse";

@Injectable()
export class OdgReportingService {

  constructor(private _odgReportingApiService: OdgReportingApiService) { }

  exportRecapitulatifDesPlats(grandCompteId?: number, cuisineCentraleId?: number, contratId?: number, dateDebut?: Date, dateFin?: Date, odgPrestationIds?: number[], odgConviveIds?: number[] ): Observable<FileResultModel> {

    const request: ExportOdgRequest = {
      grandCompteId,
      cuisineCentraleId,
      contratId,
      dateDebut,
      dateFin,
      odgPrestationIds,
      odgConviveIds
    };

    return this._odgReportingApiService.exportRecapitulatifDesPlats(request);
  }

  exportSyntheseDetailleePlats(grandCompteId?: number, cuisineCentraleId?: number, contratId?: number, dateDebut?: Date, dateFin?: Date, odgPrestationIds?: number[], odgConviveIds?: number[] ): Observable<FileResultModel> {

    const request: ExportOdgRequest = {
      grandCompteId,
      cuisineCentraleId,
      contratId,
      dateDebut,
      dateFin,
      odgPrestationIds,
      odgConviveIds
    };

    return this._odgReportingApiService.exportSyntheseDetailleePlats(request);
  }

  exportSyntheseObservations(grandCompteId?: number, cuisineCentraleId?: number, contratId?: number, dateDebut?: Date, dateFin?: Date, odgPrestationIds?: number[], odgConviveIds?: number[]): Observable<FileResultModel> {

    const request: ExportOdgRequest = {
      grandCompteId,
      cuisineCentraleId,
      contratId,
      dateDebut,
      dateFin,
      odgPrestationIds,
      odgConviveIds
    };

    return this._odgReportingApiService.exportSyntheseObservations(request);
  }

  exportSyntheseGlobale(grandCompteId?: number, cuisineCentraleId?: number, contratId?: number, dateDebut?: Date, dateFin?: Date, odgPrestationIds?: number[], odgConviveIds?: number[]): Observable<FileResultModel> {

    const request: ExportOdgRequest = {
      grandCompteId,
      cuisineCentraleId,
      contratId,
      dateDebut,
      dateFin,
      odgPrestationIds,
      odgConviveIds
    };

    return this._odgReportingApiService.exportSyntheseGlobale(request);
  }

  getPrestationsConvives(grandCompteId?: number, cuisineCentraleId?: number, contratId?: number, dateDebut?: Date, dateFin?: Date): Observable<OdgPrestationsConvivesResponse> {

    const request: OdgPrestationsConvivesRequest = {
      grandCompteId,
      cuisineCentraleId,
      contratId,
      dateDebut,
      dateFin,
    };

    return this._odgReportingApiService.getPrestationsConvives(request);
  }
}
